import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ThinkingBlockProps } from '../types';

const ThinkingBlock = ({ thinking, streaming = false }: ThinkingBlockProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  if (!thinking) {
    return null;
  }

  return (
    <div className={`thinking-block${streaming ? ' thinking-block--streaming' : ''}`}>
      <button type="button" className="thinking-block-toggle" onClick={() => setOpen((value) => !value)}>
        <i className={`ti ${open ? 'ti-chevron-up' : 'ti-chevron-down'} me-1`} />
        <i className="ti ti-brain me-1" />
        {streaming ? t('assistant.thinkingLabel') : t('assistant.thoughtProcess')}
      </button>
      {open && (
        <div className="thinking-block-body">
          <pre>{thinking}</pre>
        </div>
      )}
    </div>
  );
};

export default ThinkingBlock;
